import {
  BlockContainer,
  ProductOrderRequestListProvider,
  ProductOrderRequestList,
  Title,
  ProductOrderRequestListFilters,
} from '@components';
import { ContentLink } from '@api/types';
import { TitleAlign } from '@api/selections';

type ProductOrderRequestListBlockProps = {
  title?: string;
  contentLink?: ContentLink;
  numberItemsOnPage?: number;
  titleAlign?: TitleAlign;
};

export const ProductOrderRequestListBlock = ({
  title,
  contentLink,
  numberItemsOnPage,
  titleAlign
}: ProductOrderRequestListBlockProps) => {
  const id = contentLink?.id?.toString() || '';
  return (
    <ProductOrderRequestListProvider id={id} numberItemsOnPage={numberItemsOnPage}>
      <BlockContainer>
        <div className='product-order-request-list-block'>
          {title && <Title variant='h2' sx={{ textAlign: titleAlign || 'center' }}>{title}</Title>}
          <ProductOrderRequestListFilters />
          <ProductOrderRequestList />
        </div>
      </BlockContainer>
    </ProductOrderRequestListProvider>
  );
};
